/* ────────────────────────────────────────────────────────────────
   HS back-in-stock-veld — variant-wissel + aanmelding.

   Hoort bij snippets/klaviyo-bis.liquid. Dat rendert het blok altijd
   mee zodra het product ergens een uitverkochte variant heeft, plus
   een JSON-map { variantId: leverbaar }. Dit script:

     1. toont of verbergt het blok bij een variant-wissel
        (Dawn PUB_SUB variantChange) en werkt het variant-ID bij;
     2. handelt de aanmelding af via de Klaviyo Client API.

   De klik-afhandeling loopt via delegatie op document, zodat ze blijft
   werken als Dawn een deel van de productsectie opnieuw rendert.
   ──────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* Het script wordt door de snippet meegeladen; staat er meer dan één
     productblok op een pagina (bijv. een uitgelicht product op de homepage),
     dan mag het maar één keer luisteraars koppelen. */
  if (window.hsKlaviyoBisGeladen) return;
  window.hsKlaviyoBisGeladen = true;

  var COMPANY_ID = 'V7gUah';
  var REVISION = '2025-04-15';
  var FOUT_ALGEMEEN = 'Er ging iets mis. Probeert u het later nogmaals.';

  function blokken(sectionId) {
    var scope = null;
    if (sectionId) scope = document.querySelector('product-info[data-section="' + sectionId + '"]');
    return Array.prototype.slice.call((scope || document).querySelectorAll('.klaviyo-bis'));
  }

  function leverbaarheidsMap(wrap) {
    var scope = (wrap.closest && wrap.closest('product-info')) || document;
    var node = scope.querySelector('[data-hs-bis-map]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function herstel(wrap) {
    var form = wrap.querySelector('.klaviyo-bis__form');
    var ok = wrap.querySelector('.klaviyo-bis__success');
    var err = wrap.querySelector('.klaviyo-bis__error');
    var submit = wrap.querySelector('.klaviyo-bis__submit');
    if (form) form.hidden = false;
    if (ok) ok.hidden = true;
    if (err) {
      err.hidden = true;
      if (err.dataset.hsStandaard) err.textContent = err.dataset.hsStandaard;
    }
    if (submit) submit.disabled = false;
  }

  function bijwerken(sectionId, variant) {
    var id = (variant && variant.id != null) ? String(variant.id) : null;
    blokken(sectionId).forEach(function (wrap) {
      if (!id) { wrap.hidden = true; return; }

      var leverbaar;
      if (variant && typeof variant.available === 'boolean') {
        leverbaar = variant.available;
      } else {
        var map = leverbaarheidsMap(wrap);
        leverbaar = (map && Object.prototype.hasOwnProperty.call(map, id)) ? map[id] : true;
      }

      if (wrap.dataset.variantId !== id) {
        wrap.dataset.variantId = id;
        herstel(wrap);
      }
      wrap.hidden = (leverbaar !== false);
    });
  }

  function aanmelden(wrap) {
    var email = wrap.querySelector('.klaviyo-bis__email');
    var submit = wrap.querySelector('.klaviyo-bis__submit');
    var err = wrap.querySelector('.klaviyo-bis__error');
    var form = wrap.querySelector('.klaviyo-bis__form');
    var ok = wrap.querySelector('.klaviyo-bis__success');
    var variantId = wrap.dataset.variantId;
    if (!email || !submit || !variantId) return;

    var adres = (email.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(adres)) {
      if (err) {
        if (err.dataset.hsStandaard) err.textContent = err.dataset.hsStandaard;
        err.hidden = false;
      }
      return;
    }

    if (err) err.hidden = true;
    submit.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: adres } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (r) {
      if (r.ok || r.status === 202) {
        if (form) form.hidden = true;
        if (ok) ok.hidden = false;
      } else {
        mislukt(submit, err);
      }
    }).catch(function () {
      mislukt(submit, err);
    });
  }

  function mislukt(submit, err) {
    submit.disabled = false;
    if (err) { err.textContent = FOUT_ALGEMEEN; err.hidden = false; }
  }

  function init() {
    /* standaardtekst van de foutmelding bewaren, zodat een algemene fout
       hem overschrijft maar een reset hem weer terugzet */
    Array.prototype.forEach.call(document.querySelectorAll('.klaviyo-bis__error'), function (el) {
      if (!el.dataset.hsStandaard) el.dataset.hsStandaard = el.textContent.trim();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d) return;
        bijwerken(d.sectionId, d.variant);
      });
    }
  }

  document.addEventListener('click', function (e) {
    var submit = e.target && e.target.closest ? e.target.closest('.klaviyo-bis__submit') : null;
    if (!submit) return;
    var wrap = submit.closest('.klaviyo-bis');
    if (wrap) aanmelden(wrap);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var veld = e.target && e.target.closest ? e.target.closest('.klaviyo-bis__email') : null;
    if (!veld) return;
    e.preventDefault(); /* voorkomt dat het productformulier verstuurt */
    var wrap = veld.closest('.klaviyo-bis');
    if (wrap) aanmelden(wrap);
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
